import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { withMetrics } from '@catalogo/core-metrics';
import MagnifierSVG from '@catalogo/ui-americanas-desktop-svg/search.svg';

export const SearchFieldComponent = ({ fetchMore, term, onChange, dispatchMetrics, placeholder }) => {
  const [previousTerm, setPreviousTerm] = useState('');

  const fetchMoreQuestions = async () => {
    const sanitazedTerm = term.trim();
    if (previousTerm !== sanitazedTerm) {
      dispatchMetrics('event:track', {
        category: 'product',
        action: `Q&A - Busca`,
        label: term,
      });
      await fetchMore({ loadingTarget: 'all', term });
      setPreviousTerm(sanitazedTerm);
    }
  };

  useEffect(() => {
    if (!term && previousTerm) {
      fetchMoreQuestions();
    }
  }, [term]);

  const handleKeyPress = e => {
    e.persist();
    if (e.charCode === 13) {
      fetchMoreQuestions();
    }
  };

  return (
    <WrapperInput>
      <Input onKeyPress={handleKeyPress} value={term} placeholder={placeholder} onChange={onChange} />
      <Magnifier onClick={fetchMoreQuestions} />
    </WrapperInput>
  );
};

const SearchField = withMetrics(SearchFieldComponent);

export { SearchField };

SearchField.defaultProps = {
  term: '',
  placeholder: 'buscar por termo...',
};

const WrapperInput = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 50px;
  /* max-width: 300px; */
`;

const Input = styled.input`
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 4px;
  border: 2px solid #e9e9e9;
  padding: 12px;

  &::placeholder {
    color: #999;
  }
`;

const Magnifier = styled(MagnifierSVG)`
  position: absolute;
  top: calc(50% - 10px);
  right: 10px;
  width: 20px;
  height: 20px;
  fill: #666;
  cursor: pointer;
`;
